import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import AdminLayout from "layouts/Admin.js";
import Login from "components/login/Login";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Verificationemail from "components/Verificationemail/Verificationemail";

function App() {
  return (
    <>
      <BrowserRouter>
      <ToastContainer
        position="bottom-left"
        theme="dark"
        style={{ fontSize: 20 }}
      />
        <Switch>
          <Route path="/login" render={(props) => <Login {...props} />} />
          <Route path="/admin" render={(props) => <AdminLayout {...props} />} />
          <Route path="/verificationemail" render={(props) => <Verificationemail {...props} />} />
          <Redirect to="/login" />
        </Switch>
      </BrowserRouter>
    </>
  );
}

export default App;
